import React, { useReducer } from 'react';

export const GrantsContext = React.createContext();

const initialStatus = {
  grants: [],
};

const GrantsReducer = (state, action) => {
  switch (action.type) {
    case 'set-grants':
      return {
        grants: action.payload,
      };
    default:
      return state;
  }
};

export const GrantsContextProvider = (props) => {
  const [state, dispatch] = useReducer(GrantsReducer, initialStatus);

  return (
    <GrantsContext.Provider value={[state, dispatch]}>
      {props.children}
    </GrantsContext.Provider>
  );
};
